import actState from './state';
import { ActAddedUserTypes } from '@/models/act/act-access.interface';
import { IActMutations } from '@/models/act/store/mutations.interface';

const actMutations: IActMutations = {
	addActDashboardToAdd: (dashboard) => {
		actState.actDashboardsToAdd.push(dashboard);
	},
	addActUserToAdd: (user) => {
		actState.actUsersToAdd.push(user);
		actState.actUsersToAdd = actState.actUsersToAdd.sort((a, b) => {
			const order = {
				[ActAddedUserTypes.VALID]: 0,
				[ActAddedUserTypes.NOT_EMAIL]: 1,
				[ActAddedUserTypes.ALREADY_ADDED]: 2
			};
			return order[a.type] - order[b.type];
		});
	},
	removeActDashboardToAdd: (index) => {
		actState.actDashboardsToAdd.splice(index, 1);
	},
	removeActUserToAdd: (index) => {
		actState.actUsersToAdd.splice(index, 1);
	},
	resetActAccessModalFields: () => {
		actState.actUsersToAdd = [];
		actState.actDashboardsToAdd = [];
		actState.actSameDateForDashboards = true;
	},
	setActAccessEntries: (entries) => {
		// Force the store to update by creating a new array.
		actState.actAccessEntries = [...entries];
	},
	setActAvailableDashboards: (dashboards) => {
		actState.actAvailableDashboards = [...dashboards];
	},
	setActDashboardEndDate: (index, endDate) => {
		if (!actState.actDashboardsToAdd[index]) {
			return;
		}

		actState.actDashboardsToAdd[index].productEndDate = endDate;
	},
	setActDashboardStartDate: (index, startDate) => {
		if (!actState.actDashboardsToAdd[index]) {
			return;
		}

		actState.actDashboardsToAdd[index].productStartDate = startDate;
	},
	setActDashboardsToAdd: (dashboards) => {
		actState.actDashboardsToAdd = [...dashboards];
	},
	setModalActAccessState: (actAccessState) => {
		actState.modalActAccessState = actAccessState;
	},
	setSelectedActFilterOption: (selectedOption) => {
		actState.selectedActFilterOption = selectedOption;
	},
	setSelectedActInvoiceNumber: (selectedEntry) => {
		actState.selectedActInvoiceNumber = selectedEntry;
	},
	toggleActSameDateForDashboards: () => {
		actState.actSameDateForDashboards = !actState.actSameDateForDashboards;
		if (!actState.actSameDateForDashboards) {
			return;
		}

		// Ensure that all dashboards have the same start and end date as the first one.
		const firstDashboard = actState.actDashboardsToAdd[0];
		if (!firstDashboard) {
			return;
		}

		actState.actDashboardsToAdd = actState.actDashboardsToAdd.map((dashboard) => {
			return {
				...dashboard,
				productStartDate: firstDashboard.productStartDate,
				productEndDate: firstDashboard.productEndDate
			};
		});
	}
};

export default actMutations;
